export default __webpack_public_path__ + "static/media/OpenDyslexic-Regular.f6727f9e.ttf";